import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d9030c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "price-table__no-price"
}
const _hoisted_2 = { class: "price-table__item-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "ms-1 btn-no-styling" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-info" })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "price-table__item-price"
}
const _hoisted_5 = {
  key: 0,
  class: "price-table__item-price-before-discount me-2"
}
const _hoisted_6 = {
  key: 1,
  class: "price-table__item-no-price"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["price-table", _ctx.isLoading ? 'is-loading' : ''])
  }, [
    (!Object.keys(_ctx.ticketPrices).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.translate('shop.ticket.configuration.Select-date-to-show-prices')), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priceGroups, (priceGroup) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["price-table__item", !Object.keys(_ctx.ticketPrices).length ? 'price-table__item--blurred' : ''])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(priceGroup.singularName) + " ", 1),
          (priceGroup.description)
            ? (_openBlock(), _createBlock(_component_Popper, {
                key: 0,
                arrow: ""
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(priceGroup.description), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        (_ctx.ticketPrices[priceGroup.id])
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.ticketPrices[priceGroup.id]?.priceBeforeDiscount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "CHF " + _toDisplayString(_ctx.ticketPrices[priceGroup.id]?.priceBeforeDiscount), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" CHF " + _toDisplayString(_ctx.ticketPrices[priceGroup.id]?.price.toFixed(2)), 1)
            ]))
          : (Object.keys(_ctx.ticketPrices).length > 0 && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.translate('shop.ticket.configuration.not-available')), 1))
            : _createCommentVNode("", true)
      ], 2))
    }), 256))
  ], 2))
}